<template>
  <div :class="['card border-0 shadow-none rounded-1 mb-50 barcode-wrapper barcode-print-root', { open: toggleBarcode.open }]">
    <div class="card-body p-xl-40">
      <div class="control-panel mb-30 p-4 bg_ash rounded-1 border">
        <div class="row align-items-center g-3">
          <div class="col-lg-4">
            <h6 class="fs-16 mb-0 text-title">
              <i class="ri-store-2-line me-2"></i>Warehouse: {{ selectedWarehouseName || 'Not Selected' }}
            </h6>
          </div>
          <div class="col-lg-8">
            <div class="d-flex flex-wrap justify-content-lg-end align-items-center gap-4">
              <!-- Print Type Toggle -->
              <div class="d-flex align-items-center">
                <span class="fs-14 fw-medium text-black me-3">Print Type:</span>
                <div class="btn-group" role="group">
                  <input type="radio" class="btn-check" v-model="stateStore.printType" value="barcode" id="printBarcode" autocomplete="off">
                  <label class="btn btn-outline-primary fs-13 px-3 py-2" for="printBarcode">
                    <i class="ri-barcode-line me-1"></i> Barcode
                  </label>
                  <input type="radio" class="btn-check" v-model="stateStore.printType" value="qrcode" id="printQRcode" autocomplete="off">
                  <label class="btn btn-outline-primary fs-13 px-3 py-2" for="printQRcode">
                    <i class="ri-qr-code-line me-1"></i> QR Code
                  </label>
                </div>
              </div>

              <!-- Label Options -->
              <div class="d-flex align-items-center gap-4 border-start ps-4">
                <div class="form-check form-switch custom-switch mb-0">
                  <input class="form-check-input" type="checkbox" v-model="stateStore.showName" id="showName" role="switch">
                  <label class="form-check-label fs-14 fw-medium text-black" for="showName">Show Name</label>
                </div>
                <div class="form-check form-switch custom-switch mb-0">
                  <input class="form-check-input" type="checkbox" v-model="stateStore.showCode" id="showCode" role="switch">
                  <label class="form-check-label fs-14 fw-medium text-black" for="showCode">Show Code</label>
                </div>
                <div class="form-check form-switch custom-switch mb-0">
                  <input class="form-check-input" type="checkbox" v-model="stateStore.showPrice" id="showPrice" role="switch">
                  <label class="form-check-label fs-14 fw-medium text-black" for="showPrice">Show Price</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="barcode-wrap">
        <template v-for="product in selectedProducts" :key="product.id">
          <div v-for="n in product.qty" :key="n" class="barcode-item text-center rounded-1">
            <span v-if="stateStore.showName" class="fs-12 text-title d-block mb-2">{{ product.name }}</span>
            <div class="code-container">
              <BarcodeGenerator v-if="stateStore.printType === 'barcode'" :value="product.code" :height="50" :width="1.5" :displayValue="false" />
              <QRCodeGenerator v-else :value="product.code" :size="80" />
            </div>
            <div class="mt-2">
              <span v-if="stateStore.showCode" class="fs-12 text-title d-block">{{ product.code }}</span>
              <span v-if="stateStore.showPrice" class="fs-14 fw-bold text-black d-block mt-1">${{ product.price }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
  </template>

  <script lang="ts">
  import { defineComponent, computed, ref } from "vue";
  import stateStore from "../../../utils/store";
  import BarcodeGenerator from "../../Common/BarcodeGenerator.vue";
  import QRCodeGenerator from "../../Common/QRCodeGenerator.vue";
  
  export default defineComponent({
    name: "BarcodeWrapper",
    components: {
      BarcodeGenerator,
      QRCodeGenerator,
    },
    setup() {
      const toggleBarcode = stateStore;
      const selectedWarehouseName = computed(() => stateStore.selectedWarehouseName);
      const selectedProducts = computed(() => stateStore.selectedProducts);
      
      return {
        stateStore,
        toggleBarcode,
        selectedWarehouseName,
        selectedProducts,
      };
    },
  });
  </script>
  
  <style lang="scss" scoped>
  .barcode-wrapper {
    display: none;
    &.open {
      display: block;
    }
  }

  .control-panel {
    background-color: #f8f9fa;
    border-color: #e3e4e4 !important;
    
    .btn-group {
      .btn {
        border-color: #d1d1d1;
        color: #666;
        &:hover {
          background-color: #f0f0f0;
          color: #333;
        }
      }
      .btn-check:checked + .btn {
        background-color: #2563eb;
        border-color: #2563eb;
        color: white;
        box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
      }
    }

    .custom-switch {
      .form-check-input {
        width: 2.8em;
        height: 1.4em;
        cursor: pointer;
        &:checked {
          background-color: #2563eb;
          border-color: #2563eb;
        }
        &:focus {
          box-shadow: 0 0 0 0.25rem rgba(37, 99, 235, 0.15);
        }
      }
      .form-check-label {
        cursor: pointer;
        padding-left: 8px;
      }
    }

    @media print {
      display: none !important;
    }
  }

  .barcode-wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -7.5px;
    .barcode-item {
      border: 1px solid #e3e4e4;
      margin-bottom: 15px;
      margin: 0 7.5px 15px;
      width: calc(12.5% - 15px);
      padding: 16px 10px 17px;
      page-break-inside: avoid;
      break-inside: avoid;

      @media print {
        border: 1px solid #000 !important;
        margin: 5px !important;
        width: auto !important;
        min-width: 150px;
        display: inline-block !important;
        float: none !important;
      }

      .code-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        svg {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
  
  @media only screen and (max-width: 575px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(50% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 576px) and (max-width: 767px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(33.33% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(25% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 992px) and (max-width: 1199px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(25% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(20% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 1400px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(16.66% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 1600px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(14.28% - 15px);
      }
    }
  }
  
  @media only screen and (min-width: 1920px) {
    .barcode-wrap {
      .barcode-item {
        width: calc(12.5% - 15px);
      }
    }
  }
  </style>
